<template>
  <v-app
    id="vapp"
    class="d-flex flex-column justify-start cmpbk_lght white--text"
  >
    <!--version 0.9.02-->
    <!--//@*/*
    //    *RPD  Appv0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="cmpbk_lght white--text"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>
    <brandbar></brandbar>
    <!-- <home></home> -->
    <!-- <brandbar></brandbar> -->
    <v-main id="main" class="cmpbk_lght">
      <Transition name="fade-transition" mode="out-in">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
/* 0 media q */
@media (min-width: 0px) {
  .v-main {
    padding: 5px 0 0 0 !important;
  }
  .container {
    padding: 0 !important;
  }
  #vapp {
    /* background-color: var(--v-background-base); */
    overflow-x: auto;
    overflow-y: auto;
    max-height: 100dvh;
    height: 100dvh;
    background-color: whitesmoke;
    min-height: 100%;
    -webkit-overflow-scrolling: touch;
  }

  .img2 img {
    width: 400px;
  }

  .img3 img {
    width: 400px;
  }

  #menu-bar a {
    color: white;
    text-decoration: none;
    font-size: 1.2rem;
  }

  #menu-bar a:hover {
    color: #e3cc67;
  }

  /* #menu-bar a:visited {
    color: #b08533;
  } */

  .swal2-popup {
    /* font-size: 1.15rem !important;*/
    font-family: "Roboto", sans-serif !important;
  }
  .v-btn--active.no-active::before {
    opacity: 0 !important;
  }

  .v-btn--active.no-active:not(:hover)::before {
    opacity: 0 !important;
  }
}
/* 
@media only screen and (max-width: 600px) {
  #vapp {
    max-height: 93vh;
  }
} */

@media (min-width: 768px) {
  #menu-bar .v-toolbar__content {
    width: 100%;
    max-width: 1440px;
    height: 114px !important;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;

    background-color: #004a28;
  }
}

@media (min-width: 1025px) {
  #vapp {
    margin-left: 16px;
  }
}

@media (min-width: 2048px) {
}
</style>

<script>
import brandbar from "./brandbar.vue";
//import home from "./home";
import { bus_common } from "../mixins/bus_common";

export default {
  name: "App",
  mixins: [bus_common],
  components: { brandbar },
  data() {
    return {
      zIndex: 4000,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
  },
  methods: {
    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null
      );
    },
  },
  created() {
    this.show_loader(true);
  },
};
</script>
